import { createFileRoute, Link } from "@tanstack/react-router";
import { PageHeader } from "@/components/PageStates";
import { records, formatDate } from "@/lib/mock-data";

export const Route = createFileRoute("/app/records")({
  component: RecordsList,
});

function RecordsList() {
  return (
    <div>
      <PageHeader title="记录" />
      <ul className="space-y-2 px-4 pt-4">
        {records.map((r) => (
          <li key={r.id}>
            <Link
              to="/app/records/$id"
              params={{ id: r.id }}
              className="block rounded-[var(--r-md)] border bg-surface p-3"
            >
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0 flex-1">
                  <p className="truncate text-[var(--fs-sm)] font-medium">
                    {r.description}
                  </p>
                  <p
                    className="mt-0.5 text-[var(--fs-xs)]"
                    style={{ color: "var(--muted)" }}
                  >
                    {r.category} · {formatDate(r.createdAt)} · {r.createdBy}
                  </p>
                </div>
                {r.kind === "praise" ? (
                  <span
                    className="shrink-0 rounded-full px-2 py-0.5 text-[var(--fs-xs)]"
                    style={{
                      background: "var(--surface-2)",
                      color: "var(--muted)",
                    }}
                  >
                    表扬
                  </span>
                ) : r.kind === "reminder" ? (
                  <span
                    className="shrink-0 rounded-full px-2 py-0.5 text-[var(--fs-xs)]"
                    style={{
                      background: "var(--warn-soft)",
                      color: "var(--warn-fg)",
                    }}
                  >
                    提醒
                  </span>
                ) : (
                  <span
                    className="shrink-0 rounded-full px-2 py-0.5 text-[var(--fs-xs)] font-medium"
                    style={{
                      background: "var(--accent-soft)",
                      color: "var(--accent)",
                    }}
                  >
                    +{r.points}
                  </span>
                )}
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
